import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "q-pb-md" }
const _hoisted_2 = { class: "row items-center q-pb-xs" }
const _hoisted_3 = { class: "row items-center" }
const _hoisted_4 = { class: "row items-center no-wrap" }
const _hoisted_5 = { class: "col" }
const _hoisted_6 = { class: "q-pb-md" }
const _hoisted_7 = { class: "row items-center q-pb-xs" }
const _hoisted_8 = { class: "row items-center" }
const _hoisted_9 = { class: "row items-center no-wrap" }
const _hoisted_10 = { class: "col" }
const _hoisted_11 = { class: "q-mt-sm row q-gutter-sm" }

import { ref, computed, onMounted} from 'vue'

import InstitutionalFilterNetworkSubnetModal from '@/views/layout/modalsInstitutional/InstitutionalFilterNetworkSubnetModal.vue'
import ModalFilterPcsInstitutional from '@/views/layout/modalsInstitutional/ModalFilterPcsInstitutional.vue'
import ModalPCsInstitutional from '@/views/layout/modalsInstitutional/ModalPCsInstitutional.vue'

import { useInstitutionalStore } from '@/stores/institutionalStore'
import { useRedeSubredeStore } from '@/stores/redeSubredeStore'
import { usePCStore } from '@/stores/pcStore'


export default /*@__PURE__*/_defineComponent({
  __name: 'InstitutionalFormatSectionEdit',
  setup(__props) {

const institutionalStore = useInstitutionalStore()
const redeSubredeStore = useRedeSubredeStore()
const pcStore = usePCStore()

const showNetworkSubnetModal = ref(false)
const showPCsModal = ref(false)

/* =======================
 * REDE
 * ======================= */
const onClearRedeSubrede = () => {
  redeSubredeStore.limpar()
}

/* =======================
 * PCs
 * ======================= */
const pcLabelSelecionados = computed(() =>
  pcStore.selectedPCs.length
    ? `${pcStore.selectedPCs.length} selecionado(s)`
    : ''
)

const onClearPCs = () => {
  pcStore.setSelectedPCs([])
}

const removePC = (pcToRemove: any) => {
  pcStore.setSelectedPCs(
    pcStore.selectedPCs.filter(
      pc => pc.codpontocaptura !== pcToRemove.codpontocaptura
    )
  )
}

onMounted(async () => {
  const detail = institutionalStore.institutionalDetail
  if (!detail) return

  // ✅ Sincroniza subredes
  if (detail.redes?.length) {
    await redeSubredeStore.setSelecionadasFromBackend(detail.redes)
  }

  // ✅ Sincroniza PCs — usa detail.pcs que tem os dados completos
  if (detail.pcs?.length) {
    pcStore.setSelectedPCs(detail.pcs)
  }
  // ⚠️ fallback pcsIds: só tem o ID, sem nome — evite se possível
  // Use apenas se o backend não retornar detail.pcs populado
})



return (_ctx: any,_cache: any) => {
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_q_icon = _resolveComponent("q-icon")!
  const _component_q_input = _resolveComponent("q-input")!
  const _component_q_chip = _resolveComponent("q-chip")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _cache[4] || (_cache[4] = _createElementVNode("span", { class: "midia-app-caption-sm q-pr-sm" }, " Rede / Subrede * ", -1)),
          _createVNode(_component_q_btn, {
            outline: "",
            dense: "",
            size: "sm",
            color: "negative",
            label: "Limpar",
            "no-caps": "",
            class: "btn-inline-action q-mr-xs",
            onClick: onClearRedeSubrede
          }),
          _createVNode(_component_q_btn, {
            outline: "",
            dense: "",
            size: "sm",
            color: "negative",
            label: "Excluir",
            "no-caps": "",
            class: "btn-inline-action",
            onClick: onClearRedeSubrede
          })
        ])
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_q_input, {
            "model-value": _unref(redeSubredeStore).labelSelecionadas,
            outlined: "",
            dense: "",
            readonly: "",
            placeholder: "Selecione uma ou mais Subredes"
          }, {
            append: _withCtx(() => [
              _createVNode(_component_q_icon, {
                name: "keyboard_arrow_down",
                size: "18px"
              })
            ]),
            _: 1
          }, 8, ["model-value"])
        ]),
        _createVNode(_component_q_btn, {
          outline: "",
          dense: "",
          size: "sm",
          color: "negative",
          label: "Filtrar",
          "no-caps": "",
          class: "btn-filter-equal-height q-ml-sm",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (showNetworkSubnetModal.value = true))
        })
      ])
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", _hoisted_8, [
          _cache[5] || (_cache[5] = _createElementVNode("span", { class: "midia-app-caption-sm q-pr-sm" }, " PCs ", -1)),
          _createVNode(_component_q_btn, {
            outline: "",
            dense: "",
            size: "sm",
            color: "negative",
            label: "Limpar",
            "no-caps": "",
            class: "btn-inline-action q-mr-xs",
            onClick: onClearPCs
          }),
          _createVNode(_component_q_btn, {
            outline: "",
            dense: "",
            size: "sm",
            color: "negative",
            label: "Excluir",
            "no-caps": "",
            class: "btn-inline-action",
            onClick: onClearPCs
          })
        ])
      ]),
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("div", _hoisted_10, [
          _createVNode(_component_q_input, {
            "model-value": pcLabelSelecionados.value,
            outlined: "",
            dense: "",
            readonly: "",
            placeholder: "Selecione um ou mais PCs"
          }, {
            append: _withCtx(() => [
              _createVNode(_component_q_icon, {
                name: "keyboard_arrow_down",
                size: "18px"
              })
            ]),
            _: 1
          }, 8, ["model-value"])
        ]),
        _createVNode(_component_q_btn, {
          outline: "",
          dense: "",
          size: "sm",
          color: "negative",
          label: "Filtrar",
          "no-caps": "",
          class: "btn-filter-equal-height q-ml-sm",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (showPCsModal.value = true))
        })
      ]),
      _createElementVNode("div", _hoisted_11, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(pcStore).selectedPCs, (pc) => {
          return (_openBlock(), _createBlock(_component_q_chip, {
            key: pc.codpontocaptura,
            removable: "",
            onRemove: ($event: any) => (removePC(pc))
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(pc.codpontocaptura) + " - " + _toDisplayString(pc.nompontocaptura), 1)
            ]),
            _: 2
          }, 1032, ["onRemove"]))
        }), 128))
      ])
    ]),
    _createVNode(InstitutionalFilterNetworkSubnetModal, {
      modelValue: showNetworkSubnetModal.value,
      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((showNetworkSubnetModal).value = $event))
    }, null, 8, ["modelValue"]),
    _createVNode(ModalFilterPcsInstitutional, {
      modelValue: showPCsModal.value,
      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((showPCsModal).value = $event))
    }, null, 8, ["modelValue"]),
    _createVNode(ModalPCsInstitutional)
  ]))
}
}

})